import { useForm, Controller } from "react-hook-form";
import { useDropzone } from "react-dropzone";
import Button from "../Button";
import ImagePreviewer from "./ImagePreviewer";
import { resizeImage } from "../../utils/imageUpload.utils";
import { arrayMap } from "../../utils/array.utils";

const ImageUploader = ({
  images = [],
  setImages = () => {},
  onSubmit = () => {},
  isSubmit = false,
  singleImage = false
}) => {
  const { control, handleSubmit } = useForm();

  const onDrop = (acceptedFiles) => {
    const newImageFiles = Array.from(acceptedFiles);
    Promise.all(arrayMap(newImageFiles, resizeImage)).then((resizedFiles) => {
      const newImages = resizedFiles;
      if (singleImage) {
        setImages([newImages[0]]);
      } else {
        setImages([...images, ...newImages]);
      }
    });
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <Controller
          name="images"
          control={control}
          defaultValue={singleImage ? "" : []}
          render={({ field }) => (
            <input
              type="hidden"
              {...field}
              value={
                singleImage
                  ? images.length > 0
                    ? images[0].id
                    : ""
                  : (arrayMap(images, (image) => image.id) || []).join(",")
              }
            />
          )}
        />
        <div
          {...getRootProps()}
          style={{ marginBottom: "20px", border: "2px dashed #cccccc", padding: "20px" }}>
          <input {...getInputProps()} />
          {isDragActive ? (
            <p>Drop the images here ...</p>
          ) : (
            <p>Drag 'n' drop some images here, or click to select images</p>
          )}
        </div>

        <ImagePreviewer images={images} setImages={setImages} />

        {isSubmit && (
          <div className="text-end">
            <Button name="Submit" type="submit" color="primary" style={{ marginTop: "20px" }} />
          </div>
        )}
      </form>
    </div>
  );
};

export default ImageUploader;
